module.exports = __webpack_public_path__ + "static/6305-woodrose-12-f5176d50960a979fd989b186a7776814.jpg";